<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Activities</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Activities</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_termination_type"
                  ><i class="fa fa-plus"></i> Add Activities</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div>
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in activities" v-bind:key="item.id">
                      <td>{{index + 1}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.type == 1 ? 'General' : 'Custom'}}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown"
                            aria-expanded="false"><i class="material-icons">more_vert</i></a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" @click="selectActivity(item)"  data-toggle="modal" data-target="#edit_termination_type"><i
                                class="fa fa-pencil m-r-5"></i> Edit</a>
                            <a class="dropdown-item"  data-toggle="modal" @click="selectActivity(item)" data-target="#delete_department"><i
                                class="fa fa-trash-o m-r-5"></i> Delete</a>
                          </div>
                        </div>
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->
        <div id="add_termination_type" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Activities</h5>
                <button
                  type="button"
                  class="close" id="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label> Name <span class="text-danger">*</span></label>
                    <input
                      v-model.trim="$v.name.$model"
                      id="name"
                      name="name"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.name.$error }"
                      type="text"
                    />
                    <div
                      v-if="submitted && !$v.name.required"
                      class="invalid-feedback"
                    >
                      Name is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label> Description <span class="text-danger">*</span></label>
                    <textarea
                      v-model.trim="$v.description.$model"
                      id="description"
                      name="description"
                      class="form-control"
                      rows="4"
                      :class="{ 'is-invalid': submitted && $v.description.$error }"
                    />
                    <div
                      v-if="submitted && !$v.name.required"
                      class="invalid-feedback"
                    >
                      Description is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model.trim="$v.typeId.$model">
                      <option>Select Type</option>
                      <option :value="1">General</option>
                      <option :value="2">Custom</option>
                    </select>
                    <div
                      v-if="submitted && !$v.typeId.required"
                      class="invalid-feedback"
                    >
                      Type is required
                    </div>
                  </div>
                  <div class="submit-section">
                    <button
                      class="btn btn-primary submit-btn"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Department Modal -->

        <!-- Edit Department Modal -->
        <div id="edit_termination_type" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Activities</h5>
                <button
                  type="button"
                  class="close" id="closeEdit"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label> Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="activity.name"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                    <label> Description <span class="text-danger">*</span></label>
                    <textarea
                      v-model="activity.description"
                      id="description"
                      name="description"
                      class="form-control"
                      rows="4"
                    />
                  </div>
                  <div class="form-group">
                    <label>Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="activity.type">
                      <option>Select Type</option>
                      <option :value="1">General</option>
                      <option :value="2">Custom</option>
                    </select>
                  </div>
                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    @click="onPutSubmit"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Department Modal -->

        <!-- Delete Department Modal -->
        <div
          class="modal custom-modal fade"
          id="delete_department"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Activities</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="onDeleteSubmit"
                        class="btn btn-primary continue-btn"
                        
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a data-dismiss="modal" id="closeDelete" class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { skillsService } from "@/services/skillsService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
  },

  data() {
    return {
      name: "",
      typeId: null,
      description: "",
      activity: {},
      activities: [],
      submitted: false,
      loading: false,
      error: "",
      company: authenticationService.currentOfficeValue,
    };
  },

  validations: {
    name: { required },
    description: { required },
    typeId: { required },
  },

  methods: {
    clearModel() {
                this.name = "";
                this.description = "";
                this.typeId = null;
            },
    selectActivity (item) {
      console.log(item)
      this.activity = item
    },

    getActivities () {
      skillsService.getActivities(this.company.id)
          .then(
            model => { this.activities = model
            console.log(model) },
            error => { error = error }
          )
    },

    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      //console.log(this.name)
      skillsService.addActivity(this.name, this.typeId, this.description, this.company.id).then(
        (d) => {
          this.activities = d
          this.clearModel();
            $('#close').click();
        },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onPutSubmit() {
      console.log(this.activity);
      this.loading = true;
      skillsService
        .updateActivity(
          this.activity,
        )
        .then(
          (d) => {
            this.activities = d
            $('#closeEdit').click();
          },
          (error) => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    onDeleteSubmit() {
      console.log(this.activity);
      this.loading = true;
      skillsService
        .removeActivity(
          this.activity.id
        )
        .then(
          (id) => {
            skillsService.getActivities(this.company.id).then((r) => {
              this.activities = r;
              $('#closeDelete').click()
            });
          },
          (error) => {
            this.error = error;
            this.loading = false;
          }
        );
    },
  },

  mounted() {
    this.getActivities();
    //this.removeSkillType(this.company.id);
    // Datatable

    // if ($(".datatable").length > 0) {
    //   $(".datatable").DataTable({
    //     bFilter: false,
    //   });
    // }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },

  name: "activities",
};
</script>


// WEBPACK FOOTER //
// src/components/settings/activities.vue